/* eslint-disable react/require-default-props */
import * as React from "react";
import { Breadcrumb } from "semantic-ui-react";
import { jsx as _jsx } from "react/jsx-runtime";
const ApplicationBreadcrumbSeparator = ({
  icon = "arrow right"
}) => /*#__PURE__*/_jsx(Breadcrumb.Divider, {
  icon: icon,
  "data-sentry-element": "unknown",
  "data-sentry-component": "ApplicationBreadcrumbSeparator",
  "data-sentry-source-file": "ApplicationBreadcrumbSeparator.tsx"
});
export default ApplicationBreadcrumbSeparator;